import React, { useEffect, useReducer, useState } from "react";
import { useHistory, useLocation } from "react-router";
import Amplify, { Auth } from "aws-amplify";
//import { useBeforeunload } from "react-beforeunload";

import configData from "components/configFile.json";
import AppSpinner from "components/common/AppSpinner";
import UserProfileService from '../services/userprofile.service';
import AirlinesService from '../services/airlines.servicse';
import activityLogService from "services/activityLog.service";
import { defaultIfNullOrUndefined } from "utils/common-utils";

const SESSION_ID_KEY = 'SessionId';

const AuthContext = React.createContext({
  signOut: () => { },
  signIn: (email) => new Promise(() => { }),
  mfaChallenge: (cognitoUser, code) => new Promise(() => { }),
  userInfo: {},
});

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: configData.identityPoolId,
    // REQUIRED - Amazon Cognito Region
    region: configData.region,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: configData.userPoolId,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: configData.appClientId,
    oauth: {
      domain: configData.domain,
      scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: configData.signInUrl,
      redirectSignOut: configData.signOutUrl,
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    }

  },
  API: {
    endpoints: [
      {
        name: "IAPI",
        endpoint: configData.apiStartUrl,
        region: configData.region,
        custom_header: async () => {
          return {
            customHeaderToken: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
          }
          //return { Authorization:null} 
          //return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }      
        }
      }
    ]
  },
  Storage: {
    AWSS3: {
      bucket: 'iapi-dev-user-guides', //REQUIRED -  Amazon S3 bucket name
      region: configData.region,//OPTIONAL -  Amazon service region
      Key: "user-guides/IsraeliiAPIPortal-AdministratorGuide.pdf"
      // key: keyName.  // < ---- this needs to be `<my_bucket>/protected/<cognitoIdentityId>/<timestamp>-my_file.jpg`
    }
  }
});

const authInitState = {
  isLoggedin: false,
  isOwner: false
}

const authReducer = (state, action) => {
  let newState;
  switch (action.type) {
    case "login":
      newState = action.user;
      newState.isOwner = !newState.role; //when role is empty than user is owner
      newState.isLoggedin = true;
      break;
    case "logout":
      newState = { isLoggedin: false, isOwner: false };
      break;

    default:
      throw new Error("Invalid action");
  }

  return newState;
}

export const AuthContextProvider = (props) => {
  const [isInitDone, setIsInitDone] = useState(false);
  const [authState, authDispatch] = useReducer(authReducer, authInitState);
  const location = useLocation();
  const history = useHistory();


  useEffect(() => {
    if (sessionStorage.getItem(SESSION_ID_KEY)) {
      Auth.currentAuthenticatedUser().then(data => {
        return saveUserInfo(data);
      }).then(data => {
        setIsInitDone(true);
      })
        .catch(err => {
          setIsInitDone(true);
        })
    } else {
      setIsInitDone(true);
    }
  }, [])

  const expiredSessionHandler = (data) => {
    const currLocation = location.pathname;

    if (authState.isLoggedin) {
      cleanUp();
    }

    if (["/login", "/mfa", "/expiredsession"].findIndex(x => currLocation.toLowerCase().startsWith(x)) < 0) {
      setTimeout(() => {
        history.push("/ExpiredSession")
      }, 0);
    }
  }

  useEffect(() => {
    const intRef = setInterval(() => {
      Auth.currentSession()
        .then(data => {
          // console.log("token: "+ data.getAccessToken().getJwtToken());
        })
        .catch(expiredSessionHandler)
    }, 5000);
    return () => {
      clearInterval(intRef)
    }
  }, [location,expiredSessionHandler])

 
  const signInHandler = (email) => {
    return UserProfileService.signIn(email).then(
      res => {
        sessionStorage.setItem(SESSION_ID_KEY, res.Session);
        return res;
      }
    )
  };

  const mfaChallenge = (cognitoUser, code) => {
    return UserProfileService.answerCustomChallenge(cognitoUser, code).then(res => {
      if (!res.attributes) {
        throw new Error("no attributes")
      }
      activityLogService.addActivityLog({ UserName: res.attributes.email, ActivityType: "login", Session: cognitoUser.Session });
      return saveUserInfo(res);
    }).catch(err => {
      //console.log(err);
      return Promise.reject("Invalid code. Please try again.")
    })
  };

  const saveUserInfo = (cognitoUser) => {
    const tmpUser = {}
    tmpUser.session = sessionStorage.getItem(SESSION_ID_KEY);
    tmpUser.email = cognitoUser.attributes.email;
    tmpUser.airlineCode = cognitoUser.attributes["custom:airline_code"];
    tmpUser.faxNumber = cognitoUser.attributes["custom:fax"];
    tmpUser.role = cognitoUser.attributes["custom:role"];
    tmpUser.lastName = defaultIfNullOrUndefined(cognitoUser.attributes.family_name, "");
    tmpUser.firstName = defaultIfNullOrUndefined(cognitoUser.attributes.given_name, "");
    tmpUser.phoneNumber = cognitoUser.attributes.phone_number;
    return AirlinesService.getUserAirline(tmpUser.airlineCode).then(
      res => {
        tmpUser.airline = res;
        authDispatch({ type: "login", user: tmpUser })
        return tmpUser;
      }
    ).catch(
      err => {
        //console.log(err);
        return err;
      }
    );
  }

  const signOutHandler = () => {
    if (authState.email) {
      activityLogService.addActivityLog({ UserName: authState.email, ActivityType: "logout", Session: authState.session });
    }
    return Auth.signOut()
      .then((data) => {
        cleanUp();
      }).catch((error) => {
        //console.log(error);
      });
  };

  const cleanUp = () => {
    authDispatch({ type: "logout" })
    sessionStorage.removeItem(SESSION_ID_KEY);
  }


  return (
    isInitDone ?
      <AuthContext.Provider
        value={{ signIn: signInHandler, mfaChallenge: mfaChallenge, signOut: signOutHandler, userInfo: authState }}>
        {props.children}

      </AuthContext.Provider>
      : <AppSpinner style={{ height: '100%' }} />
  );
};

export default AuthContext;
